import { useEffect, useState } from "react";
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import {
    ContentState,
    EditorState,
    convertFromHTML,
    convertToRaw,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import axios from "axios";
import { baseURL } from "../../../../config/api";
import colorConfigs from "../../../../config/colorConfigs";
import useAuth from "../../../../hook/useAuth";
import { PleasewaitPopup } from "../../../../components/PleasewaitPopup";
import { validateMin } from "../../../../utils/validateMin";

type Props = {
    state: string;
    setState: (value: string) => void;
    zip: string;
    setZip: (value: string) => void;
}

export const GeneralSettings = ({ state, setState, zip, setZip }: Props) => {
    const { auth }: any = useAuth();
    const [disabled, setDisabled] = useState<boolean>(true);

    const [id, setId] = useState<string>("");
    const [isGeneralSettings, setIsGeneralSetttings] = useState<boolean>(true);
    const [collectZIPCode, setCollectZIPCode,] = useState<string>("No");
    const [prohibitTheUsageofPrePaidCards, setProhibitTheUsageofPrePaidCards] = useState<string>("No");
    const [prohibitUsageOfDebitCardsforSaveCreditCardFunctionality,
        setProhibitUsageOfDebitCardsforSaveCreditCardFunctionality] = useState<string>("No");

    const [sendFailedTransactionEmail, setSendFailedTransactionEmail] = useState<string>("No");

    const [isEmailSettings, setIsEmailSettings] = useState<boolean>(true);
    const [allowCaptureforHigherAmountsThanAuthorized,
        setAllowCaptureforHigherAmountsThanAuthorized] = useState<string>("No");

    const [disableManualUpdateOfTransactionsToPaid,
        setDisableManualUpdateOfTransactionsToPaid] = useState<string>("No");

    const [disableManualUpdateofTransactionsToFailed,
        setDisableManualUpdateofTransactionsToFailed] = useState<string>("No");

    const [paperSizeforPaymentReceipts, setPaperSizeforPaymentReceipts] = useState<string>("A0");

    const [maxDaysToKeepAuthorizations, setMaxDaysToKeepAuthorizations] =
        useState<string>("");
    const [failedTransactionEmailReceiver, setFailedTransactionEmailReceiver] =
        useState<string>("");

    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const [isAdvanced, setIsAdvanced] = useState<boolean>(true);
    const [emailContentForRecurringChargesWith3DS,
        setEmailContentForRecurringChargesWith3DS] = useState<string>("");

    const [emailSubjectforRecurringChargesWith3DS,
        setEmailSubjectforRecurringChargesWith3DS] = useState<string>("");

    useEffect(() => {
        axios
            .get(`${baseURL}paymentGatewaySettings`)
            .then((response) => {
                setId(response.data.id);
                setMaxDaysToKeepAuthorizations(
                    response.data.maxDaysToKeepAuthorizations
                );
                setCollectZIPCode(response.data.collectZIPCode ? "Yes" : "No");
                setProhibitTheUsageofPrePaidCards(response.data.prohibitTheUsageofPrePaidCards ? "Yes" : "No");
                setProhibitUsageOfDebitCardsforSaveCreditCardFunctionality
                    (response.data.prohibitUsageOfDebitCardsforSaveCreditCardFunctionality ? "Yes" : "No");
                setSendFailedTransactionEmail(response.data.sendFailedTransactionEmail ? "Yes" : "No");
                setFailedTransactionEmailReceiver(response.data.failedTransactionEmailReceiver);
                setEmailSubjectforRecurringChargesWith3DS(response.data.emailSubjectforRecurringChargesWith3DS);
                setEmailContentForRecurringChargesWith3DS(response.data.emailContentForRecurringChargesWith3DS);
                setPaperSizeforPaymentReceipts(response.data.paperSizeforPaymentReceipts);
                setAllowCaptureforHigherAmountsThanAuthorized
                    (response.data.allowCaptureforHigherAmountsThanAuthorized ? "Yes" : "No");
                setDisableManualUpdateOfTransactionsToPaid
                    (response.data.disableManualUpdateOfTransactionsToPaid ? "Yes" : "No");
                setDisableManualUpdateofTransactionsToFailed
                    (response.data.disableManualUpdateofTransactionsToFailed ? "Yes" : "No");
                setState(response.data.state);
                setZip(response.data.zip);

                setEditorState(
                    EditorState.createWithContent(
                        ContentState.createFromBlockArray(
                            convertFromHTML(response.data.emailContentForRecurringChargesWith3DS).contentBlocks,
                            convertFromHTML(response.data.emailContentForRecurringChargesWith3DS).entityMap
                        )
                    )
                );

                setPleaseWaitPopup(false);
            })
            .catch((error) => {
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);

        await axios
            .put(
                `${baseURL}paymentGatewaySettings?userId=${auth?.id}`,
                JSON.stringify({
                    id,
                    maxDaysToKeepAuthorizations,
                    collectZIPCode: collectZIPCode === "Yes" ? true : false,
                    prohibitTheUsageofPrePaidCards: prohibitTheUsageofPrePaidCards === "Yes" ? true : false,
                    prohibitUsageOfDebitCardsforSaveCreditCardFunctionality: prohibitUsageOfDebitCardsforSaveCreditCardFunctionality === "Yes" ? true : false,
                    sendFailedTransactionEmail: sendFailedTransactionEmail === "Yes" ? true : false,
                    failedTransactionEmailReceiver,
                    emailSubjectforRecurringChargesWith3DS,
                    emailContentForRecurringChargesWith3DS,
                    paperSizeforPaymentReceipts,
                    allowCaptureforHigherAmountsThanAuthorized: allowCaptureforHigherAmountsThanAuthorized === "Yes" ? true : false,
                    disableManualUpdateOfTransactionsToPaid: disableManualUpdateOfTransactionsToPaid === "Yes" ? true : false,
                    disableManualUpdateofTransactionsToFailed: disableManualUpdateofTransactionsToFailed === "Yes" ? true : false,
                    state,
                    zip,
                }),
                {
                    headers: {
                        "Content-Type": "application/json"
                    },
                    withCredentials: false,
                }
            )
            .then(() => {
                setPleaseWaitPopup(false)
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
            });
    };

    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );

    useEffect(() => {
        setEmailContentForRecurringChargesWith3DS(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    }, [editorState]);

    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <div className="w-full mt-2">
                        <div className={`w-full pb-4`}>
                            <div className={`flex justify-between items-center p-2 border-b border-secondary`}>
                                <div className="flex items-center gap-1.5">
                                    <h2 className={`text-lg font-semibold text-secondary`}>Payment Gateway Settings</h2>
                                </div>

                                {
                                    disabled && (
                                        <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border border-secondary text-white flex items-center gap-1.5`}
                                            onClick={() => setDisabled(false)}
                                        >
                                            <span className={`material-symbols-outlined text-[25px] font-light text-secondary`}>
                                                edit
                                            </span>
                                            <span className={`text-xs font-medium text-secondary`}>Edit</span>
                                        </button>
                                    )
                                }
                            </div>

                            <div className="mt-2 p-2">
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <h5 className="mb-0 flex justify-start items-center cursor-pointer select-none"
                                        onClick={() => setIsGeneralSetttings(!isGeneralSettings)}
                                    >
                                        {isGeneralSettings ? (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 24 24"
                                                fill="#2f3739"
                                            >
                                                <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" />
                                            </svg>
                                        ) : (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 24 24"
                                                fill="#2f3739"
                                            >
                                                <path d="M9.29 6.71 13.17 10.59 9.29 14.47 10.7 15.88 16.58 10 10.7 4.12z" />
                                            </svg>
                                        )}{" "}
                                        <div className="w-full flex flex-row justify-between items-center">
                                            <div style={{ color: "#2f3739" }}>General Settings</div>
                                            <div
                                                className="w-1/2 text-[10px] font-normal text-end"
                                                style={{ color: "#2f3739" }}
                                            >
                                                General Settings for this Tenant
                                            </div>
                                        </div>
                                    </h5>
                                    <hr />

                                    <div className="w-full px-2">
                                        {isGeneralSettings &&
                                            <div className="grid grid-cols-3 gap-6">
                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Max Days to Keep Authorizations?</label>
                                                        <input
                                                            type="number"
                                                            min={0}
                                                            className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                            value={maxDaysToKeepAuthorizations}
                                                            onChange={(e) =>
                                                                setMaxDaysToKeepAuthorizations(validateMin(e.target.value, 0).toString())
                                                            }
                                                            disabled={disabled}
                                                            required
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Collect ZIP Code</label>
                                                        <RadioGroup
                                                            row
                                                            value={collectZIPCode}
                                                            onChange={(e) => setCollectZIPCode(e.target.value)}
                                                        >
                                                            <FormControlLabel

                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Prohibit the Usage of Pre-Paid Cards?</label>
                                                        <RadioGroup
                                                            row
                                                            value={prohibitTheUsageofPrePaidCards}
                                                            onChange={(e) => setProhibitTheUsageofPrePaidCards(e.target.value)}
                                                        >
                                                            <FormControlLabel

                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>
                                                </div>

                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Prohibit the Usage of Debit Cards for Save Credit Card Functionality</label>
                                                        <RadioGroup
                                                            row
                                                            value={prohibitUsageOfDebitCardsforSaveCreditCardFunctionality}
                                                            onChange={(e) => setProhibitUsageOfDebitCardsforSaveCreditCardFunctionality(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        <h5 className="mb-0 flex justify-start items-center cursor-pointer select-none"
                                            onClick={() => setIsEmailSettings(!isEmailSettings)}
                                        >
                                            {isEmailSettings ? (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 24 24"
                                                    fill="#2f3739"
                                                >
                                                    <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" />
                                                </svg>

                                            ) : (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 24 24"
                                                    fill="#2f3739"
                                                >
                                                    <path d="M9.29 6.71 13.17 10.59 9.29 14.47 10.7 15.88 16.58 10 10.7 4.12z" />
                                                </svg>

                                            )}{" "}
                                            <div className="w-full flex flex-row justify-between items-center">
                                                <div style={{ color: "#2f3739" }}>Email Settings</div>
                                            </div>
                                        </h5>
                                        <hr />

                                        {isEmailSettings &&
                                            <>
                                                <div className="grid grid-cols-3 gap-6">
                                                    <div className="space-y-4">
                                                        <div>
                                                            <label className={`text-xs font-medium text-secondary`}>Send Failed Transaction Email</label>
                                                            <RadioGroup
                                                                row
                                                                value={sendFailedTransactionEmail}
                                                                onChange={(e) => setSendFailedTransactionEmail(e.target.value)}
                                                            >
                                                                <FormControlLabel
                                                                    value="Yes" control=
                                                                    {<Radio
                                                                        disabled={disabled}
                                                                        sx={{
                                                                            color: "gray",
                                                                            "&.Mui-checked": {
                                                                                color: "blue",
                                                                            },
                                                                        }}
                                                                    />} label="Yes"
                                                                    sx={{
                                                                        color: "#2f3739"
                                                                    }}
                                                                />
                                                                <FormControlLabel value="No" control={
                                                                    <Radio
                                                                        disabled={disabled}
                                                                        sx={{
                                                                            color: "gray",
                                                                            "&.Mui-checked": {
                                                                                color: "blue",
                                                                            },
                                                                        }}
                                                                    />} label="No"
                                                                    sx={{
                                                                        color: "#2f3739"
                                                                    }}
                                                                />
                                                            </RadioGroup>
                                                        </div>
                                                    </div>

                                                    <div className="space-y-4">
                                                        <div>
                                                            <label className={`text-xs font-medium text-secondary`}>Failed Transaction Email Receiver</label>
                                                            <input
                                                                type="text"
                                                                className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                                value={failedTransactionEmailReceiver}
                                                                onChange={(e) =>
                                                                    setFailedTransactionEmailReceiver(e.target.value)
                                                                }
                                                                disabled={disabled}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium text-secondary`}>Email Subject For Recurring Charges With 3DS</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                        value={emailSubjectforRecurringChargesWith3DS}
                                                        onChange={(e) =>
                                                            setEmailSubjectforRecurringChargesWith3DS(e.target.value)
                                                        }
                                                        disabled={disabled}
                                                        required
                                                    />
                                                </div>

                                                {/* <div
                                                    className="quill-wrapper my-5"
                                                    style={{
                                                        ...({
                                                            '--quill-text-color': '#ffffff',
                                                            '--quill-bg-color': '#121212',
                                                        }),
                                                    } as React.CSSProperties}
                                                >
                                                    <label className={`text-xs font-medium text-secondary`}>Email Content For Recurring Charges With 3DS</label>
                                                   <ReactQuill
                                                className="custom-quill"
                                                theme="snow"
                                                modules={modules}
                                                value={answer}
                                                onChange={setAnswer}
                                            />
                                                </div> */}
                                            </>
                                        }

                                        <h5 className="mb-0 flex justify-start items-center cursor-pointer select-none"
                                            onClick={() => setIsAdvanced(!isAdvanced)}
                                        >
                                            {isAdvanced ? (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 24 24"
                                                    fill="#2f3739"
                                                >
                                                    <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" />
                                                </svg>

                                            ) : (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 24 24"
                                                    fill="#2f3739"
                                                >
                                                    <path d="M9.29 6.71 13.17 10.59 9.29 14.47 10.7 15.88 16.58 10 10.7 4.12z" />
                                                </svg>

                                            )}{" "}
                                            <div className="w-full flex flex-row justify-between items-center">
                                                <div style={{ color: "#2f3739" }}>Advanced</div>
                                            </div>
                                        </h5>
                                        <hr />

                                        {isAdvanced &&
                                            <div className="grid grid-cols-3 gap-6">
                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Paper Size For Payment Receipts</label>
                                                        <select
                                                            className={`w-full px-[8px] py-[10px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                            value={paperSizeforPaymentReceipts}
                                                            disabled={disabled}
                                                            onChange={(e) => setPaperSizeforPaymentReceipts(e.target.value)}
                                                        >
                                                            <option value="A0">A0</option>
                                                            <option value="A1">A1</option>
                                                            <option value="A2">A2</option>
                                                            <option value="A3">A3</option>
                                                            <option value="A4">A4</option>
                                                            <option value="A5">A5</option>
                                                            <option value="A6">A6</option>
                                                            <option value="A7">A7</option>
                                                            <option value="A8">A8</option>
                                                            <option value="A9">A9</option>
                                                            <option value="B0">B0</option>
                                                            <option value="B1">B1</option>
                                                            <option value="B2">B2</option>
                                                            <option value="B3">B3</option>
                                                            <option value="B4">B4</option>
                                                            <option value="B5">B5</option>
                                                            <option value="B6">B6</option>
                                                            <option value="B7">B7</option>
                                                            <option value="B8">B8</option>
                                                            <option value="B9">B9</option>
                                                            <option value="B10">B10</option>
                                                            <option value="C5E">C5E</option>
                                                            <option value="Comm10E">Comm10E</option>
                                                            <option value="DLE">DLE</option>
                                                            <option value="Executive">Executive</option>
                                                            <option value="Folio">Folio</option>
                                                            <option value="Ledger">Ledger</option>
                                                            <option value="Legal">Legal</option>
                                                            <option value="Letter">Letter</option>
                                                            <option value="Ledger">Tabloid</option>
                                                        </select>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Allow Capture For Higher Amounts than Authorized?</label>
                                                        <RadioGroup
                                                            row
                                                            value={allowCaptureforHigherAmountsThanAuthorized}
                                                            onChange={(e) => setAllowCaptureforHigherAmountsThanAuthorized(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Disable Manual Update of Transaction to Paid</label>
                                                        <RadioGroup
                                                            row
                                                            value={disableManualUpdateOfTransactionsToPaid}
                                                            onChange={(e) => setDisableManualUpdateOfTransactionsToPaid(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>
                                                </div>

                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Disable Manual Update of Transaction to Failed</label>
                                                        <RadioGroup
                                                            row
                                                            value={disableManualUpdateofTransactionsToFailed}
                                                            onChange={(e) => setDisableManualUpdateofTransactionsToFailed(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {/* Buttons */}
                                        <div className="flex gap-4 mt-6">
                                            {
                                                !disabled && (
                                                    <Button variant="contained"
                                                        sx={{
                                                            backgroundColor: colorConfigs.btn.main.bg,
                                                            marginTop: "10px"
                                                        }}
                                                        type="submit">
                                                        Save
                                                    </Button>
                                                )
                                            }
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
};
